export default __webpack_public_path__ + "a5a7962.png";